import React from "react";
import { Row, Image, Flex, Skeleton } from "antd";
import Learningpoints from "../../../assets/images/svgs/ic_learningpoints_programdesc.svg";
import Category from "../../../assets/images/svgs/ic_type_moduledesc.svg";
import { useTranslation } from "react-i18next";
// import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";
import { textTitleProfile } from "../../../config/constant/color/index";

const ModalContentAdditional = ({
  loading,
  wraperStyle,
  rowImageStyle,
  thumbnail,
  divRightStyle,
  pModuleStyle,
  titleModuleDescStyle,
  moduleName,
  rowBottomFirstStyle,
  rowBottomSecondStyle,
  pointImageWidth,
  totalPoint,
  moduleType,
  desc,
  overDue,
}) => {
  const { t, i18n } = useTranslation();

  return (
    <>
      <div style={wraperStyle}>
        <Flex style={{ display: "flex", flexDirection: "column" }}>
          <Row className="row-image" style={rowImageStyle}>
            {loading ? (
              <Skeleton.Avatar
                active
                shape="square"
                style={{ width: "165px", height: "113px", borderRadius: "8px" }}
              />
            ) : (
              thumbnail
            )}
          </Row>
          <div className="div-right" style={divRightStyle}>
            {loading ? (
              <Skeleton.Input
                active
                size={16}
                style={{ marginBottom: "10px", minWidth: "70px" }}
              />
            ) : (
              <p className="p-program" style={pModuleStyle}>
                {t("feature.feature_mylj.main_content.program")}
              </p>
            )}
            <Row>
              {loading ? (
                <Skeleton.Input
                  active
                  size={22}
                  style={{ marginRight: "8px", minWidth: "300px" }}
                />
              ) : (
                <span
                  className="title-journey-desc"
                  style={titleModuleDescStyle}
                >
                  {moduleName}
                </span>
              )}
            </Row>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: "10px",
                justifyContent: "start",
                alignItems: "center",
              }}
            >
              {overDue !== undefined ? overDue : null}

              {loading ? (
                <Skeleton.Input
                  active
                  size={20}
                  style={{ marginTop: "15px", minWidth: "250px" }}
                />
              ) : (
                <>
                  <Row className="row-bottom" style={rowBottomFirstStyle}>
                    <Image
                      width={pointImageWidth}
                      src={Category}
                      preview={false}
                    />
                    <span
                      style={{
                        color: textTitleProfile,
                        fontWeight: "500",
                        margin: "0 5px",
                        lineHeight: "normal",
                        marginTop: "3px",
                      }}
                    >
                      {moduleType !== null && moduleType !== "" ? (
                        moduleType
                      ) : (
                        <>-</>
                      )}
                    </span>
                  </Row>
                  <Row className="row-bottom" style={rowBottomSecondStyle}>
                    <Image
                      width={pointImageWidth}
                      src={Learningpoints}
                      preview={false}
                    />
                    {totalPoint !== undefined ? totalPoint : null}
                  </Row>
                </>
              )}
            </div>
            {loading ? <Skeleton paragraph={{ rows: 10 }} active /> : desc}
          </div>
        </Flex>
      </div>
    </>
  );
};

export default ModalContentAdditional;
